package com.artvending.warden

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

abstract class Scanner {
	var started by mutableStateOf(false)
	
	abstract fun pause()
	
	abstract fun start()
	
	@Composable
	abstract fun ScannerView(onQrCodeScanned: (String) -> Unit)
}